import React from 'react'
import Select from 'react-select';
import { PERIOD, GENRES, ATTRIBUTES } from "../../../../constants/programSectionTypes";
import Translation from '../../../Translation/cont/Translation'

const AddNewSectionFilterSelect = ({form, field, changeOption, filterActive, genres, id, filter, selectSettings, currentGenreOption, currentAttributeOption, currentPeriodOption}) => {
    let options = []
    let currentValue = ''
    let selectRef = ''

    const additionalClass = filterActive === id ? ' has-value' : ''
    
    const onClick = (currentID) => {
        if(filterActive === currentID) {
            const option = ''
            const id = ''
            
            changeOption(option, id, form, field)
        } else {
            selectRef.focus();
            selectRef.onMenuOpen();
        }
    }

    const onChange = (option, id) => {
        if(!option) {
            const option = ''
            const id = ''
            
            changeOption(option, id, form, field)
            
        } else {
            changeOption(option, id, form, field)
        }
    }

    // if(id === GENRES) {
    //     currentValue = currentGenreOption

    //     genres.map((genre) => {
    //         const value = genre.toLowerCase()
    //         const label = genre
    //         options.push({value,label})
    //     })
    // } else {
    if(id === GENRES) {
        currentValue = currentGenreOption
    } else if(id === ATTRIBUTES) {
        currentValue = currentAttributeOption
    } else {
        currentValue = currentPeriodOption
    }
    
    const currentFilter = filter.filter

    
    _.keys(currentFilter).map((filterID) => {
        const value = filterID
        const label = PERIOD === id ? <Translation id={currentFilter[filterID]} /> : currentFilter[filterID]

        options.push({value,label})
    })

    return (
            <div className="control control-select control-radio">
                <Select {...selectSettings}
                    options={options}
                    ref={ref => { selectRef = ref; }}
                    // placeholder={filter.title}
                    placeholder={<Translation id={filter.transIdTitle}/>}

                    value={currentValue} 
                    onChange={(value) => onChange(value, id)}
                />
                <div onClick={() => onClick(id)} className={"control_indicator" + additionalClass}></div>
            </div>
    )
}

export default AddNewSectionFilterSelect